import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      Oneness © {new Date().getFullYear()} . All rights reserved.
    </footer>
  );
};

export default Footer;
